module.exports = __webpack_public_path__ + "img/smg.2.89b88895.png";